










import Vue from "vue";

// Vue components
import InfoButton from "./InfoButton.vue";

export default Vue.extend({
    components: {
        InfoButton,
    },
});
